module.exports = __webpack_public_path__ + "img/41_39.b1ebf37c.png";